import React, { Component } from 'react'
import Toggle from 'components/controls/toggle'

import Button from 'components/button/button'

import Checkbox from 'components/input/checkbox'
import SearchMini from 'components/search-mini/search-mini'
import ToggleButtons from 'components/toggle-buttons/toggle-buttons'

class SectionControls extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			checkboxProps,
			toggleButtonProps,
			buttonShelfHidden,
			noSearch,
			onSearchTermChange,
			searchTerm,
			toggleOptions,
			hideToggle,
			toggleState,
			toggleChangeCallback,
			buttons,
			customShelfContent
		} = this.props

		let buttonShelfClass = 'button-shelf'

		if (buttonShelfHidden) {
			buttonShelfClass += ' hidden'
		}

		return (
			<div className="section-controls-header clear" >
				{(!noSearch && onSearchTermChange) &&
					<SearchMini
						searchTerm={searchTerm}
						onSearchTermChange={onSearchTermChange}
					/>
				}
				{customShelfContent}
				{(toggleOptions && !hideToggle) &&
					<Toggle toggleState={toggleState} toggleChangeCallback={toggleChangeCallback} toggleOptions={toggleOptions} />
				}
				{checkboxProps && checkboxProps.map((object, index) => {
					return (
						<label
							key={index}
							className={object.isChecked ? "checkbox checked" : "checkbox"}
							onClick={e => e.stopPropagation()}
						>
							<Checkbox
								isChecked={object.isChecked}
								onChange={_ => { object.callback() }}
							/>
							{object.label}
						</label>
					)
				})}
				<ToggleButtons 
					buttons={toggleButtonProps}
				/>
				{
					buttons ?
						<ul className={buttonShelfClass}>
							{buttons.map((buttonProps, index) => {
								return (
									<li key={index} className="tooltip-trigger">
										<Button {...buttonProps} />
										{
											buttonProps.tooltip ?
												<div className="tooltip">
													{buttonProps.tooltip}
												</div>
												: null
										}
										{buttonProps.extra || null}
									</li>
								)
							})}
						</ul>
						:
						null
				}
			</div>
		);
	}

} export default SectionControls;



// WEBPACK FOOTER //
// ./src/components/controls/section-controls.jsx